import { useTranslation } from "react-i18next";
import Title from 'src/pages/home/components/title/Title';
import styles from "./styles.module.css";
import img1 from "src/assets/images/wherehouse/1.avif";
import img2 from "src/assets/images/wherehouse/2.avif";
import img3 from "src/assets/images/wherehouse/3.avif";
import img4 from "src/assets/images/wherehouse/4.avif";
import { isRTL } from "src/utils/global";




const Warehouse = () => {
    const { t } = useTranslation(["home"]);

    return (
        <section  data-aos="fade-up"  className={`${styles.sectionContainer} ${isRTL() && styles.rtl}`}>
            <div className="container">
                <div className={`row ${styles.row_reverse}`}>

                    <div className="col-12 col-sm-10 col-lg-6 mb-4 mb-lg-0 m-auto">
                        <div className={styles.imageGallery}>
                            <div className="row">
                                <div className="col-6 px-2">
                                    <div className={styles.leftContainer}>
                                        <a href={img1} target="_blank" className={styles.imgContainer}>
                                            <img src={img1} alt={`EL-ENTISAR AL-ZAHER Wherehouse Image 1`}
                                                className={styles.image} />
                                        </a>
                                        <a href={img2} target="_blank" className={styles.imgContainer}>
                                            <img src={img2} alt={`EL-ENTISAR AL-ZAHER Wherehouse Image 1`}
                                                className={styles.image} />
                                        </a>
                                    </div>
                                </div>
                                <div className="col-6 px-2">
                                    <div className={styles.rightContainer}>
                                        <a href={img3} target="_blank" className={styles.imgContainer}>
                                            <img src={img3} alt={`EL-ENTISAR AL-ZAHER Wherehouse Image 3`}
                                                className={styles.image} />
                                        </a>
                                        <a href={img4} target="_blank" className={styles.imgContainer}>
                                            <img src={img4} alt={`EL-ENTISAR AL-ZAHER Wherehouse Image 4`}
                                                className={styles.image} />
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="col-12 col-lg-6 m-auto">
                        <div className={styles.content}>
                            <div className={styles.title}>
                                <Title lgTitle={t("warehouse.title.lg")} smTitle={t("warehouse.title.sm")} />
                            </div>
                            <p className={styles.description}>{t('warehouse.description')}</p>
                            <ul className={styles.list}>
                                <li>
                                    {t('warehouse.list.main_warehouses')}
                                </li>
                                <li>
                                    {t('warehouse.list.subsidiary_warehouses')}
                                </li>
                            </ul>
                            <p className={styles.conclusion}>{t('warehouse.conclusion')}</p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Warehouse;
